import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import { useParams } from "react-router-dom";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { useGetStateCodeByIdQuery, useUpdateStateCodeMutation } from "../stateCodeApi";
import { useDispatch } from "react-redux";
import { tgxApi } from "../../../../app/tgxApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { isReadable } from "stream";

interface props {
    isReadOnly?: boolean
}

const StateCodeDetailInfo: FC<props> = ({ isReadOnly }) => {
    const { codeId } = useParams();
    const [stateCodes, setStatecodes] = useState<any>({});
    const dispatch = useDispatch();

    const stateCodeData = useGetStateCodeByIdQuery(codeId ?? skipToken);
    const [showButtons, setShowButtons] = useState<boolean>(false);
    const [updateStateCodeApi, updateStateCodeApiResponse] = useUpdateStateCodeMutation()

    useEffect(() => {
        if (stateCodeData?.data) {
            setStatecodes({
                ...(stateCodeData?.data)
            });
        }
    }, [stateCodeData?.data]);

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;
        setStatecodes((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
        setShowButtons(true);
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let obj = {
            ...stateCodes,
        }
        const UpdateSystemProperty = async () => {
            await updateStateCodeApi({
                id: codeId,
                requestBody: obj,
            }).unwrap();
        };
        await handleRTKQuery(UpdateSystemProperty, () => {
            setShowButtons(false);
        });
    }

    const handCancel = async (e?: React.MouseEvent<HTMLButtonElement>) => {
        e?.preventDefault();
        dispatch(tgxApi.util.invalidateTags([
            "stateCodeById"
        ]));
        setShowButtons(false);
    };

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md ">
            <Form
                onSubmit={handleSubmit}
                fields={
                    <>
                        <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                            <h5 className="font-semibold text-surface-0">State Code Details
                            </h5>
                            {showButtons && !isReadOnly && (
                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => handCancel(),
                                                type: "close",
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: "Submit",
                                                type: "submit",
                                                isLoading: (updateStateCodeApiResponse.isLoading),
                                            },
                                            buttonType: "button",
                                        }
                                    ]}
                                    align="end"
                                    gap={2}
                                />
                            )}
                        </div>
                        <div className="p-2">
                            <InputField
                                name="name"
                                label="Name"
                                value={stateCodes?.name || ""}
                                onChange={handleOnChange}
                                required
                                placeholder="Enter Name..."
                                disabled={isReadOnly}
                            />
                        </div>

                    </>
                }
            />
        </div>
    );
};

export default StateCodeDetailInfo;